/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateBlockRegistrationDomainDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('block')],
    ['domain', codecString],
    [
        'matchSubdomains',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'match_subdomains',
    ],
]);
export class CreateBlockRegistrationDomainData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateBlockRegistrationDomainDataParser.decode(input).map(res => new CreateBlockRegistrationDomainData(res));
    }
    static unsafeDecode(input) {
        return CreateBlockRegistrationDomainData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateBlockRegistrationDomainDataParser.encode(data);
    }
    static schema() {
        return CreateBlockRegistrationDomainDataParser.schema();
    }
}
